const MapOption = () => {
    const option = {
        backgroundColor: "#f9f9f9",
        title: {
            text: '',
            left: 'center',
            top: 10
        },
        tooltip: {
            formatter: (params) => {
                // console.log(params);
                // console.log(params.seriesName + '-' + params.name + '省：<br/>' + '价格：' + params.data.price + '<br/>涨跌值：' + params.data.value + '<br/>涨跌幅：' + params.data.chgRadio)
                let date = params.data ? params.data.date : '';
                if(params.data){
                    const originalName = params.data.originalName ? '('+ params.data.originalName +')' : '';
                    let html = '<div class="textLeft">' + date + '<br>' + params.name +  originalName + '：<br/>' + '价格：' + params.data.price + '<br/>涨跌值：' + params.data.value + '<br/>涨跌幅：' + params.data.chgRadio + '%</div>';
                    if (params.data.towStr) {
                        const voOriginalName = params.data.voOriginalName ? '('+ params.data.voOriginalName +')' : '';
                        html += '<div style="width: 100%; border-top: 1px solid #fff; margin: 5px 0;"></div>'
                        html += '<div class="textLeft">' + params.data.voName + voOriginalName + '：<br/>' + '价格：' + params.data.voPrice + '<br/>涨跌值：' + params.data.voValue + '<br/>涨跌幅：' + params.data.voChgRadio + '%</div>';
                    }
                    return html;
                }else{
                    return '<div class="textLeft">' + params.name + '：<br/>' + '价格：暂无<br/>涨跌值：暂无<br/>涨跌幅：暂无' + '</div>';
                }
            }
        }, // 鼠标移到图里面的浮动提示框
        visualMap: {
            show: true,
            type: 'piecewise',
            itemHeight: 10,
            showLabel: true,
            left: 20,
            bottom: 20,
            pieces: [
                {gt: 50, label: '大涨 >50', color: '#a30000'}, 
                {gt: 1, lte: 50, label: '上涨 1~50', color: '#da1c1c'},
                {value: 0, label: '平稳 0', color: '#0378bf'},
                {gte: -50, lte: -1, label: '下跌 -1~-50', color: '#3dcc5e'}, 
                {lt: -50, label: '大跌 <-50', color: '#02a728'} 
            ],
        }, 
        series: [{
            name: '', // 浮动框的标题
            type: 'map',
            map: 'china',
            // left: 100,
            top: 50,
            // right: 100,
            label: { show: true, color: 'rgba(255,255,255,1)' },
            itemStyle: {
                areaColor: '#aaa',
                borderColor: '#ccc'
            },
            zoom: 1.2,
            emphasis: {
                label: {color: '#000'},
                itemStyle: { areaColor: '#ccc' }
            },
            data: []
        }]
    }
    return option;
}

const LineOption = () => {
    var option = { // 进行相关配置
        color: colorPalette,
        title: {
            text: '',
            left: 0,
            top: 0,
            textStyle: {
                color: '#666',
                fontSize: 14
            }
        },
        tooltip: {
            show: true,
            trigger: 'axis'
        },
        grid: {
            top: 40,
            right: 10,
            bottom: 30,
            left: 45
        },
        xAxis: {
            show: true,
            type: 'category',
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#aaa'
                }
            },
            boundaryGap: false,
            axisTick: { show: false },
            data: []
        },
        yAxis: {
            show: true,
            type: 'value',
            min: 0,
            max: 0,
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#eee',
                    type: 'dotted'
                }
            }
        },
        series: []
        /* 
        {
            type: 'line',
            name: '',
            smooth: true,
            smoothMonotone: 'none',
            lineStyle: {
                color: '#eee'
            },
            data: [820, 932, 901, 934, 1290, 1330, 1320]
        }, {
            type: 'line',
            name: '',
            smooth: true,
            smoothMonotone: 'none',
            lineStyle: {
                color: 'blue'
            },
            data: [80, 902, 701, 434, 290, 1330, 130]
        } */
    }
    return option;
}

const colorPalette = ['#e45d3e', '#d392ce', '#e7b483', '#86e6aa', '#2ec7c9', '#27727B'];
const LineOption_2 = () => {
    const option = {
        color: colorPalette,
        title: {
            show: false
        },
        tooltip: {
            confine: true,
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: { show: true },
        grid: {
            top: 30,
            left: 0,
            right: 1,
            bottom: 0,
            containLabel: true
        },
        xAxis: {
            axisLabel: {
                color: '#666',
                // rotate: 90
                // interval:0//横轴信息全部显示
            },
            axisLine: {
                lineStyle: {
                    color: '#aaa',
                    width: 2
                }
            },
            axisTick: {
                show: false
            },
            splitLine: {
                show: false,
                lineStyle: {
                    color: '#aaa'
                    //type: 'dashed'
                }
            },
            type: 'category',
            data: []
        },
        yAxis: {
            axisLabel: {
                interval: 0,
                // fontSize: echarts_fontsize,
                color: '#666'
            },
            min: function(value) {
                var min_line = Math.floor(value.min - (value.max - value.min) * 0.25);
                if(value.min >= 0 && min_line < 0) {
                    min_line = 0;
                }
                return min_line
            },
            max: function(value) {
                return Math.ceil(value.max + (value.max - value.min) * 0.25)
            },
            axisLine: {
                lineStyle: {
                    color: '#aaa',
                    width: 2
                }
            },
            axisTick: {
                show: false
            },
            splitLine: {
                lineStyle: {
                    color: '#ededed'
                    //type: 'dashed'
                }
            },
            type: 'value',
    
            nameTextStyle: {
                color: "#aaaaaa"
            },
            nameGap: '5'
        },
        series: []
    }
    return option;
}

const KOption = (data) => {
    var upColor = '#ec0000';
    var upBorderColor = '#8A0000';
    var downColor = '#00da3c';
    var downBorderColor = '#008F28';

    // 数据意义：开盘(open)，收盘(close)，最低(lowest)，最高(highest)
    var data0 = splitData(data); 


    function splitData(rawData) {
        var categoryData = [];
        var values = []
        for (var i = 0; i < rawData.length; i++) {
            categoryData.push(rawData[i].splice(0, 1)[0]);
            values.push(rawData[i])
        }
        return {
            categoryData: categoryData,
            values: values
        };
    }

    function calculateMA(dayCount) {
        var result = [];
        for (var i = 0, len = data0.values.length; i < len; i++) {
            if (i < dayCount) {
                result.push('-');
                continue;
            }
            var sum = 0;
            for (var j = 0; j < dayCount; j++) {
                sum += data0.values[i - j][1];
            }
            result.push(sum / dayCount);
        }
        return result;
    }



    const option = {
        // title: {
        //     text: '上证指数',
        //     left: 0
        // },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross'
            },
            formatter (params) {
                console.log(params)
                let data1 = params[0].data;
                let data2 = params[1];
                let data3 = params[2];
                let data4 = params[3];
                let data5 = params[4];
                let html = `<div class="textLeft">
                            ${params[0].axisValue}<br>
                            开盘价: ${data1[1]}<br/>收盘价: ${data1[2]}<br/>最低值: ${data1[3]}<br/>最高值: ${data1[4]}
                            ${data2 ? ('<br/>' + data2.seriesName + ': ' + (data2.data != '-' ? data2.data.toFixed(2) : '-')) : ''}
                            ${data3 ? ('<br/>' + data3.seriesName + ': ' + (data3.data != '-' ? data3.data.toFixed(2) : '-')) : ''}
                            ${data4 ? ('<br/>' + data4.seriesName + ': ' + (data4.data != '-' ? data4.data.toFixed(2) : '-')) : ''}
                            ${data5 ? ('<br/>' + data5.seriesName + ': ' + (data5.data != '-' ? data5.data.toFixed(2) : '-')) : ''}
                            </div>`
                return html;
            }
        },
        legend: {
            left: '8%',
            data: ['日K', 'MA5', 'MA10', 'MA20', 'MA30'],
            
        },
        grid: {
            left: '8%',
            right: '6%',
            top: '30px',
            bottom: '65px'
        },
        xAxis: {
            type: 'category',
            data: data0.categoryData,
            scale: true,
            boundaryGap : false,
            axisLine: {onZero: false},
            splitLine: {show: false},
            splitNumber: 20,
            min: 'dataMin',
            max: 'dataMax'
        },
        yAxis: {
            scale: true,
            splitArea: {
                show: true
            }
        },
        dataZoom: [
            {
                type: 'inside',
                start: 50,
                end: 100
            },
            {
                show: true,
                type: 'slider',
                y: '92%',
                start: 50,
                end: 100
            }
        ],
        series: [
            {
                name: '日K',
                type: 'candlestick',
                data: data0.values,
                itemStyle: {
                    normal: {
                        color: upColor,
                        color0: downColor,
                        borderColor: upBorderColor,
                        borderColor0: downBorderColor
                    }
                },
                markPoint: {
                    label: {
                        normal: {
                            formatter: function (param) {
                                return param != null ? Math.round(param.value) : '';
                            }
                        }
                    },
                    data: [
                        {
                            name: 'XX标点',
                            coord: ['2013/5/31', 2300],
                            value: 2300,
                            itemStyle: {
                                normal: {color: 'rgb(41,60,85)'}
                            }
                        },
                        {
                            name: 'highest value',
                            type: 'max',
                            valueDim: 'highest'
                        },
                        {
                            name: 'lowest value',
                            type: 'min',
                            valueDim: 'lowest'
                        },
                        {
                            name: 'average value on close',
                            type: 'average',
                            valueDim: 'close'
                        }
                    ],
                    tooltip: {
                        formatter: function (param) {
                            return param.name + '<br>' + (param.data.coord || '');
                        }
                    }
                },
                markLine: {
                    symbol: ['none', 'none'],
                    data: [
                        [
                            {
                                name: 'from lowest to highest',
                                type: 'min',
                                valueDim: 'lowest',
                                symbol: 'circle',
                                symbolSize: 10,
                                label: {
                                    normal: {show: false},
                                    emphasis: {show: false}
                                }
                            },
                            {
                                type: 'max',
                                valueDim: 'highest',
                                symbol: 'circle',
                                symbolSize: 10,
                                label: {
                                    normal: {show: false},
                                    emphasis: {show: false}
                                }
                            }
                        ],
                        {
                            name: 'min line on close',
                            type: 'min',
                            valueDim: 'close'
                        },
                        {
                            name: 'max line on close',
                            type: 'max',
                            valueDim: 'close'
                        }
                    ]
                }
            },
            {
                name: 'MA5',
                type: 'line',
                data: calculateMA(5),
                smooth: true,
                lineStyle: {
                    normal: {opacity: 0.5}
                }
            },
            {
                name: 'MA10',
                type: 'line',
                data: calculateMA(10),
                smooth: true,
                lineStyle: {
                    normal: {opacity: 0.5}
                }
            },
            {
                name: 'MA20',
                type: 'line',
                data: calculateMA(20),
                smooth: true,
                lineStyle: {
                    normal: {opacity: 0.5}
                }
            },
            {
                name: 'MA30',
                type: 'line',
                data: calculateMA(30),
                smooth: true,
                lineStyle: {
                    normal: {opacity: 0.5}
                }
            },

        ]
    };
    return option;
}
export { MapOption, LineOption, LineOption_2, KOption }